<template>
  <div class="general-details">
    <div :class="fullscreenGeneralInfo ? 'mb-4 full-general-details-table' : 'mb-4 general-details-table'">
      <table style="width:100%">
        <tbody :key="indextr " v-for="(tr,indextr) in general_details">
          <tr>
            <td width="50px" class="text-dark">Q :</td>
            <td class="text-black">{{tr.question.question_number}} - {{tr.field_name}}</td>
          </tr>
          <tr>
            <td width="50px" class="text-black">A :</td>
            <td
              class="w-full text-dark"
              contenteditable
              v-html="tr.answer"
              @blur="event => checkList(event,tr,'answer')"
            >{{ tr.answer }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="mt-4 text-right">
      <vs-button
        class="vs-component vs-button vs-button-primary vs-button-filled"
        color="warning"
        :disabled="button_loading"
        button="submit"
        @click="saveData()"
      >{{ $t('labels.save_data') }}</vs-button>
    </div>
  </div>
</template>
<style scoped>
</style>
<script>
export default {
  components: {},
  data() {
    return {
      general_details: [],
      totalPage: 1,
      currentx: 1,
      limit: parseInt(process.env.VUE_APP_PER_PAGE),
      showfilter: false,
      search: null,
      service: 0,
      services_drop: []
    };
  },
  props: ["consultantId","fullscreenGeneralInfo"],
  computed: {},
  mounted() {
     this.getGeneralInformation();
  },
  methods: {
    async getGeneralInformation() {
      let input = {
        consultant_id: this.consultantId
      };
      let response = await this.getHTTPPostResponse(
        "project-consultant-general-information/list/" + this.$route.params.id,
        input
      );
      if (response) {
        let data = response.data;
        let general_details = data.consultant_general_information;
        this.general_details = general_details;
      }
    },
    async saveData() {
      let input = this.general_details;
      let response = await this.getHTTPPostResponse(
        "project-consultant-general-information/store",
        input,
        "",
        true
      );
    },
    async checkList(event, item, type) {
      this.general_details.forEach(el => {
        if (el.id === item.id) {
          el[type] = event.target.innerText;
        }
      });
      this.general_details = this.general_details;
    }
  }
};
</script>
<style scoped>
th {
  border: 1px solid black;
  background: rgba(var(--vs-dark), 1) !important;
  color: #fff !important;
  font-weight: 600;
}
td.text-primary,
td.text-black {
  border-right: none !important;
}
</style>

